<template>
    <div class="toolbox-header">
        <button class="btn-icon icon-close" @click="closeToolbox" :disabled="loading"></button>
        <button class="btn-icon btn-edit icon-edit" @click="item.step = 1" v-show="item.step > 1" :disabled="loading"></button>
        <h2>Import</h2>
        <div class="subheader">
            <div class="entry" v-show="getFileName && item.step > 1">
                <div class="label">Datei</div>
                <div class="desc">{{ getFileName }}</div>
            </div>
        </div>
    </div>
</template>

<script>
  import Dropzone from 'dropzone'

  Dropzone.autoDiscover = false
  export default {
    props: {
      item: {
        type: Object,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      closeToolbox () {
        this.$emit('close')
      }
    },
    computed: {
      getFileName () {
        if (!this.item.getDropzone()) {
          return false
        }
        let files = this.item.getDropzone().files
        if (files.length === 0) {
          return false
        }

        return files[0].name
      }
    }
  }
</script>

<style scoped>

</style>
